import { render, staticRenderFns } from "./ExibicaoPromocao.vue?vue&type=template&id=4d1c02ea&scoped=true&class=template&"
import script from "./ExibicaoPromocao.vue?vue&type=script&lang=js&"
export * from "./ExibicaoPromocao.vue?vue&type=script&lang=js&"
import style0 from "./ExibicaoPromocao.vue?vue&type=style&index=0&id=4d1c02ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1c02ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VIcon,VRow})
